import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthBootstrapService } from '../services/auth-bootstrap.service';

@Injectable({
  providedIn: 'root'
})
export class AuthBootstrapResolver implements Resolve<boolean> {
  constructor(private readonly authBootstrapService: AuthBootstrapService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      await this.authBootstrapService.bootstrap('route-resolver');
    } catch (error) {
      console.error('AuthBootstrapResolver error:', error);
    }
    return true;
  }
}
